/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportZutrittskontrolleProtokollCsv$Json } from '../fn/zutrittskontrolle-protokoll/export-zutrittskontrolle-protokoll-csv-json';
import { ExportZutrittskontrolleProtokollCsv$Json$Params } from '../fn/zutrittskontrolle-protokoll/export-zutrittskontrolle-protokoll-csv-json';
import { exportZutrittskontrolleProtokollCsv$Plain } from '../fn/zutrittskontrolle-protokoll/export-zutrittskontrolle-protokoll-csv-plain';
import { ExportZutrittskontrolleProtokollCsv$Plain$Params } from '../fn/zutrittskontrolle-protokoll/export-zutrittskontrolle-protokoll-csv-plain';
import { getZutrittskontrolleProtokoll$Json } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-json';
import { GetZutrittskontrolleProtokoll$Json$Params } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-json';
import { getZutrittskontrolleProtokoll$Plain } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-plain';
import { GetZutrittskontrolleProtokoll$Plain$Params } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-plain';
import { getZutrittskontrolleProtokollFilterOptionen$Json } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-filter-optionen-json';
import { GetZutrittskontrolleProtokollFilterOptionen$Json$Params } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-filter-optionen-json';
import { getZutrittskontrolleProtokollFilterOptionen$Plain } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-filter-optionen-plain';
import { GetZutrittskontrolleProtokollFilterOptionen$Plain$Params } from '../fn/zutrittskontrolle-protokoll/get-zutrittskontrolle-protokoll-filter-optionen-plain';
import { ZutrittskontrolleEventDto } from '../models/zutrittskontrolle-event-dto';
import { ZutrittskontrolleProtokollFilterOptionenDto } from '../models/zutrittskontrolle-protokoll-filter-optionen-dto';

@Injectable({ providedIn: 'root' })
export class ZutrittskontrolleProtokollApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getZutrittskontrolleProtokoll()` */
  static readonly GetZutrittskontrolleProtokollPath = '/v1/zutrittskontrolle/protokoll';

  /**
   * Holt die Zutrittsereignisse (Zutrittsprotokoll) gefiltert und seitenweise, neueste zuerst.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getZutrittskontrolleProtokoll$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokoll$Plain$Response(params?: GetZutrittskontrolleProtokoll$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZutrittskontrolleEventDto>>> {
    return getZutrittskontrolleProtokoll$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Zutrittsereignisse (Zutrittsprotokoll) gefiltert und seitenweise, neueste zuerst.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getZutrittskontrolleProtokoll$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokoll$Plain(params?: GetZutrittskontrolleProtokoll$Plain$Params, context?: HttpContext): Observable<Array<ZutrittskontrolleEventDto>> {
    return this.getZutrittskontrolleProtokoll$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ZutrittskontrolleEventDto>>): Array<ZutrittskontrolleEventDto> => r.body)
    );
  }

  /**
   * Holt die Zutrittsereignisse (Zutrittsprotokoll) gefiltert und seitenweise, neueste zuerst.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getZutrittskontrolleProtokoll$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokoll$Json$Response(params?: GetZutrittskontrolleProtokoll$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ZutrittskontrolleEventDto>>> {
    return getZutrittskontrolleProtokoll$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Zutrittsereignisse (Zutrittsprotokoll) gefiltert und seitenweise, neueste zuerst.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getZutrittskontrolleProtokoll$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokoll$Json(params?: GetZutrittskontrolleProtokoll$Json$Params, context?: HttpContext): Observable<Array<ZutrittskontrolleEventDto>> {
    return this.getZutrittskontrolleProtokoll$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ZutrittskontrolleEventDto>>): Array<ZutrittskontrolleEventDto> => r.body)
    );
  }

  /** Path part for operation `exportZutrittskontrolleProtokollCsv()` */
  static readonly ExportZutrittskontrolleProtokollCsvPath = '/v1/zutrittskontrolle/protokoll/csv';

  /**
   * Exportiert das gefilterte Zutrittsprotokoll als CSV (Semikolon-getrennt, UTF-8 mit BOM).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportZutrittskontrolleProtokollCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportZutrittskontrolleProtokollCsv$Plain$Response(params?: ExportZutrittskontrolleProtokollCsv$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportZutrittskontrolleProtokollCsv$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Exportiert das gefilterte Zutrittsprotokoll als CSV (Semikolon-getrennt, UTF-8 mit BOM).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportZutrittskontrolleProtokollCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportZutrittskontrolleProtokollCsv$Plain(params?: ExportZutrittskontrolleProtokollCsv$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.exportZutrittskontrolleProtokollCsv$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Exportiert das gefilterte Zutrittsprotokoll als CSV (Semikolon-getrennt, UTF-8 mit BOM).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportZutrittskontrolleProtokollCsv$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportZutrittskontrolleProtokollCsv$Json$Response(params?: ExportZutrittskontrolleProtokollCsv$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportZutrittskontrolleProtokollCsv$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Exportiert das gefilterte Zutrittsprotokoll als CSV (Semikolon-getrennt, UTF-8 mit BOM).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportZutrittskontrolleProtokollCsv$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportZutrittskontrolleProtokollCsv$Json(params?: ExportZutrittskontrolleProtokollCsv$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.exportZutrittskontrolleProtokollCsv$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getZutrittskontrolleProtokollFilterOptionen()` */
  static readonly GetZutrittskontrolleProtokollFilterOptionenPath = '/v1/zutrittskontrolle/protokoll/filter-optionen';

  /**
   * Holt die Auswahlmöglichkeiten für die Filter des Zutrittsprotokolls.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getZutrittskontrolleProtokollFilterOptionen$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokollFilterOptionen$Plain$Response(params?: GetZutrittskontrolleProtokollFilterOptionen$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>> {
    return getZutrittskontrolleProtokollFilterOptionen$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Auswahlmöglichkeiten für die Filter des Zutrittsprotokolls.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getZutrittskontrolleProtokollFilterOptionen$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokollFilterOptionen$Plain(params?: GetZutrittskontrolleProtokollFilterOptionen$Plain$Params, context?: HttpContext): Observable<ZutrittskontrolleProtokollFilterOptionenDto> {
    return this.getZutrittskontrolleProtokollFilterOptionen$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>): ZutrittskontrolleProtokollFilterOptionenDto => r.body)
    );
  }

  /**
   * Holt die Auswahlmöglichkeiten für die Filter des Zutrittsprotokolls.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getZutrittskontrolleProtokollFilterOptionen$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokollFilterOptionen$Json$Response(params?: GetZutrittskontrolleProtokollFilterOptionen$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>> {
    return getZutrittskontrolleProtokollFilterOptionen$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Holt die Auswahlmöglichkeiten für die Filter des Zutrittsprotokolls.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getZutrittskontrolleProtokollFilterOptionen$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getZutrittskontrolleProtokollFilterOptionen$Json(params?: GetZutrittskontrolleProtokollFilterOptionen$Json$Params, context?: HttpContext): Observable<ZutrittskontrolleProtokollFilterOptionenDto> {
    return this.getZutrittskontrolleProtokollFilterOptionen$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ZutrittskontrolleProtokollFilterOptionenDto>): ZutrittskontrolleProtokollFilterOptionenDto => r.body)
    );
  }

}
